"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENV = void 0;
const tslib_1 = require("tslib");
const dotenv = tslib_1.__importStar(require("dotenv"));
// Dynamically load the appropriate .env file based on NODE_ENV
const envFile = `environments/.env.${process.env.NODE_ENV || "dev"}`;
dotenv.config({ path: envFile });
exports.ENV = process.env;
